<template>
  <div class="landing-device landing-section">
    <div class="container">
        <h2 data-aos="fade-up-right">{{ $t('landing.device.title', 'landing') }}</h2>
        <div class="row line1">
            <div class="col-sm">
                <h3>{{ $t('landing.device.subtitle_1', 'landing') }}</h3>
                <p>{{ $t('landing.device.description_1', 'landing') }}</p>
            </div>
            <div class="col-sm img-col">
                <div class="wrap-img" data-aos="fade-left">
                    <img src="@/assets/img/landing/1c.png" class="circle">
                    <img src="@/assets/img/landing/1b.png" 
                        data-aos="zoom-in" data-aos-delay="500" data-aos-id="bounce" id="bounce">
                    <img src="@/assets/img/landing/1d.png">
                </div>
            </div>
        </div>
        <div class="row line2">
            <div class="col-sm img-col">
                <div class="wrap-img" data-aos="fade-right">
                    <img src="@/assets/img/landing/1c.png" class="circle">
                    <img src="@/assets/img/landing/salts.png"
                        data-aos="zoom-in" data-aos-delay="500" data-aos-id="bounce2" id="bounce2">
                    <img src="@/assets/img/landing/Salt_device.png">
                </div>
            </div>
            <div class="col-sm">
                <h3>{{ $t('landing.device.subtitle_2', 'landing') }}</h3>
                <p v-html="$t('landing.device.description_2', 'landing')"></p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>

export default {
    name      : 'Device',
    mounted() {
        // BOUNCE
        document.addEventListener('aos:in:bounce', ({ detail }) => {
            if (detail) {
                setTimeout(() => {
                    document.getElementById('bounce').classList.add("bounce");
                }, 1000);
            }
        });
        document.addEventListener('aos:out:bounce', ({ detail }) => {
            if (detail) {
                setTimeout(() => {
                    document.getElementById('bounce').classList.remove("bounce");
                }, 1000);
            }
        });
        // BOUNCE2
        document.addEventListener('aos:in:bounce2', ({ detail }) => {
            if (detail) {
                setTimeout(() => {
                    document.getElementById('bounce2').classList.add("bounce2");
                }, 1000);
            }
        });
        document.addEventListener('aos:out:bounce2', ({ detail }) => {
            if (detail) {
                setTimeout(() => {
                    document.getElementById('bounce2').classList.remove("bounce2");
                }, 1000);
            }
        });
    },
}
</script>

<style scoped lang="scss">
    @import '@/assets/scss/_variables.scss';

    .landing-device { 
        background-color: $teal-light;
        margin-top: -98px;
        padding-bottom: 160px;
        overflow: auto;

        h2 {
            margin-top: 86px;
            text-align: center;

            font-family: 'Robusta TL Pro';
            font-style: normal;
            font-weight: 900;
            font-size: 40px;
            line-height: 78px;

            /* identical to box height, or 194% */
            text-align: center;
            text-transform: uppercase;

            color: $blue;
        }

        h3 {
            color: $blue;
            margin-bottom: 30px;
        }

        p {
            font-family: 'Rubik';
            font-style: normal;
            font-weight: 400;
            font-size: 18px;
            line-height: 25px;

            /* or 139% */

            /* black */
            color: #101010;
        }

        .line1>div:first-child, .line2>div:last-child {
            display: flex;
            flex-direction: column;
            justify-content: center;
        }


        .img-col {
            position: relative;
            height: 638px;
        }

        .wrap-img {
            display: flex;
            position: absolute;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 780px;

            img {
                height: 100%;
                position: absolute;

                &.circle {
                    height: calc(100% - 15%);
                }
            }
        }

        .line2 {
            text-align: right;

            .wrap-img {
                right: 0;
            }
        }
    }

    @media only screen and (max-width: $break-sm){
        .landing-device { 

            h2 {
                font-size: 30px;
                line-height: 30px;
                margin-bottom: 50px;
            }

            .img-col {
                position: relative;
                height: auto;
            }

            .line1 {
                >div:first-child {
                    order: 1;
                }

                .img-col {
                    order: 0;
                }
            }

            h3 {
                margin-top: 30px;
                font-size: 20px;
                line-height: 25px;
                text-align: center;
            }

            p {
                font-size: 16px;
                line-height: 20px;
                text-align: center;
                color: #101010;
            }

            .wrap-img {
                position: static;
                height: auto;
                aspect-ratio: 1 / 1;
                width: 100%;

                img {
                    height: 100%;
                    width: 100%;
                    position: absolute;
                    object-fit: contain;

                    &.circle {
                        height: auto;
                        width: 75%;
                    }
                }
            }

            .line2 {
                margin-top: 35px;
            }

        }
    }
</style>